import React from 'react';
import { Button } from '@/components/ui/button';

interface EditControlsProps {
  isEditing: boolean;
  loading: boolean;
  onStartEdit: () => void;
  onCancel: () => void;
  startEditText?: string;
  cancelText?: string;
  saveText?: string;
  loadingText?: string;
  className?: string;
}

export const EditControls: React.FC<EditControlsProps> = ({
  isEditing,
  loading,
  onStartEdit,
  onCancel,
  startEditText = "Start Editing",
  cancelText = "Cancel Edits",
  saveText = "Update",
  loadingText = "Updating...",
  className
}) => (
  <div className={`pt-4 ${className || ''}`}>
    {!isEditing ? (
      <Button 
        type="button" 
        onClick={onStartEdit} 
        className="w-full"
        variant="outline"
      >
        {startEditText}
      </Button>
    ) : (
      <div className="flex gap-3">
        <Button 
          type="button" 
          onClick={onCancel} 
          variant="outline" 
          className="flex-1"
        >
          {cancelText}
        </Button>
        <Button 
          type="submit" 
          disabled={loading} 
          className="flex-1"
        >
          {loading ? loadingText : saveText}
        </Button>
      </div>
    )}
  </div>
);